import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import {
  ResourceSummaryDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveBomItemResource = createAsyncThunk<any, any, { state: any }>(
  'bom/save-resource',
  async (
    {
      bomItemIds,
      workingStepType,
      resource,
      controllerInstance,
    }: {
      bomItemIds: string[]
      workingStepType: WorkingStepType
      resource: ResourceSummaryDto
      controllerInstance: BomItemController
    },
    thunkAPI
  ) => {
    const { projectId } = getContext(thunkAPI.getState)

    try {
      bomItemIds.forEach((bomItemId) => {
        thunkAPI.dispatch(
          newProjectActions.setBomItemWorkingSteps({
            bomItemId: bomItemId,
            workingStepType: workingStepType,
            workingStep: {
              resource: {
                ...resource,
              },
            },
          })
        )
      })

      await controllerInstance.SetBomItemResource(
        bomItemIds,
        workingStepType,
        resource.id
      )

      thunkAPI.dispatch(newProjectActions.setBomItemInSearch(bomItemIds[0]))
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
